import { EnvService } from "../../environments/environment.factory";
import { HttpClient } from "@angular/common/http";
import { PhotoInterface as IPhoto } from "../../models/interfaces/projectFormMonsters/parts/photo.interface";
import { ProjectInterface as IProject } from "../../models/interfaces/project.interface";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { prepareAuthHeaders } from "../headers";

/*
  Generated class for the AuthProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ProjectProvider {
  private environment: any;

  constructor(private http: HttpClient, private env: EnvService) {
    this.environment = env;
  }

  public syncProject(project: IProject) {
    const headers = prepareAuthHeaders();
    return this.http.post(
      `${this.environment.api}/v1/project`,
      { project },
      { headers }
    );
  }

  public syncStatus(project: IProject) {
    const headers = prepareAuthHeaders();
    return this.http.post(
      `${this.environment.api}/v1/project/${project.id}/sync-status`,
      { project },
      { headers }
    );
  }

  public getSavedProjects() {
    const headers = prepareAuthHeaders();
    return this.http.get(`${this.environment.api}/v1/project`, { headers });
  }

  public getProjects(archived = false) {
    const headers = prepareAuthHeaders();
    return this.http.get(`${this.environment.api}/v1/project`, {
      headers,
      params: { archived: `${archived}` },
    });
  }

  public storePhotos(formData: FormData) {
    let headers = prepareAuthHeaders();
    return this.http.post(`${this.environment.api}/v1/photos`, formData, {
      headers,
    });
  }

  public storeV2(images) {
    let headers = prepareAuthHeaders();
    return this.http.post(
      `${this.environment.api}/v1/photos-v2`,
      { images },
      { headers }
    );
  }

  public getSavedImages(monsterId) {
    let headers = prepareAuthHeaders();
    return this.http.get(
      `${this.environment.api}/v1/get-photos-v2/${monsterId}`,
      { headers }
    );
  }

  public deleteV2(file_id) {
    let headers = prepareAuthHeaders();
    return this.http.post(
      `${this.environment.api}/v1/delete-photos-v2/${file_id}`,
      {},
      { headers }
    );
  }

  /**
   * Updates a Photo in the back-end with "base64Image" as the new image.
   *
   * This method is used after the photo-editor modal is closed. The edited photo
   * is a base64 string and should replace the old photo in the back-end.
   */
  public updatePhotoByBase64(photoId: number, base64Image: string) {
    let headers = prepareAuthHeaders();

    return this.http.put(
      `${this.environment.api}/v1/update-photo-base64/${photoId}`,
      {
        base64: base64Image,
      },
      { headers }
    );
  }

  public destroyPhoto(id: number) {
    let headers = prepareAuthHeaders();
    return this.http.delete(`${this.environment.api}/v1/photos/${id}`, {
      headers,
    });
  }

  public forceDestroyPhoto(id: number) {
    let headers = prepareAuthHeaders();
    return this.http.delete(
      `${this.environment.api}/v1/photos/${id}/forceDestroy`,
      { headers }
    );
  }

  public restorePhoto(photo: IPhoto) {
    let headers = prepareAuthHeaders();
    return this.http.put(
      `${this.environment.api}/v1/photos/${photo.id}`,
      { photo },
      { headers }
    );
  }

  public requestLabAnalysis(projectId) {
    let headers = prepareAuthHeaders();

    return this.http.post(
      `${this.environment.api}/v1/project/${projectId}/request-lab-analysis`,
      {},
      { headers }
    );
  }

  public validProjectNumber(projectNumber, projectId) {
    let headers = prepareAuthHeaders();

    return this.http.post(
      `${this.environment.api}/v1/validation/project-number`,
      {
        project_id: projectId,
        project_number: projectNumber,
      },
      { headers }
    );
  }

  public delete(projectId: number) {
    let headers = prepareAuthHeaders();

    return this.http.delete(`${this.environment.api}/v1/project/${projectId}`, {
      headers,
    });
  }

  public deleteMonster(projectId: number, monsterId: number) {
    let headers = prepareAuthHeaders();

    return this.http.delete(
      `${this.environment.api}/v1/project/${projectId}/monster/${monsterId}`,
      { headers }
    );
  }

  public uploadAddresses(project: IProject, file: File) {
    const headers = prepareAuthHeaders();

    const formData = new FormData;
    formData.append('file', file);

    return this.http.post(
      `${this.environment.api}/v1/project/${project.id}/addresses`,
      formData,
      { headers }
    );
  }
}



// WEBPACK FOOTER //
// ./src/providers/project/project.ts